/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRowExpandEnabled_FromProps = void 0;
var isRowExpandEnabled_FromProps = function isRowExpandEnabled_FromProps(props) {
  var enableRowExpand = props.enableRowExpand,
    expandedRows = props.expandedRows,
    defaultExpandedRows = props.defaultExpandedRows,
    renderRowDetails = props.renderRowDetails,
    renderDetailsGrid = props.renderDetailsGrid;
  if (enableRowExpand !== undefined) {
    return !!enableRowExpand;
  }
  var tmpComputedExpandedRows = expandedRows || defaultExpandedRows;
  return tmpComputedExpandedRows !== undefined || typeof renderRowDetails === 'function' || typeof renderDetailsGrid === 'function';
};
exports.isRowExpandEnabled_FromProps = isRowExpandEnabled_FromProps;